
















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { registrationService } from '@/services/RegistrationService';
import Advert from '@/components/activation/Advert.vue';
import LanguageSwitch from '@/components/activation/LanguageSwitch.vue';
import EUProjectInfo from '@/components/activation/EUProjectInfo.vue';

@Component({
  components: {
    Advert,
    LanguageSwitch,
    EUProjectInfo,
  },
})
export default class Registration extends Vue {
  name = '';
  email = '';
  password = '';
  passwordRepeat = '';
  acceptTerms = false;
  isRegistered = false;
  sendMessageInfo = false;
  isActiveNameValidation = false;
  isActiveEmailValidation = false;
  emailAddressAlreadyInUse = false;
  emailBlacklisted = false;
  isActivePasswordValidation = false;
  isActivePasswordRepeatValidation = false;
  isActiveTermsValidation = false;
  isLoading = false;

  @Watch('email')
  onEmailChange(email: string) {
    this.$store.commit('userFormData/setEmail', email);
  }
  @Watch('password')
  onPasswordChange(password: string) {
    this.$store.commit('userFormData/setPass', password);
  }

  mounted() {
    this.email = this.$store.state.userFormData.email;
    this.password = this.$store.state.userFormData.password;
  }

  isWeakPassword() {
    let strength = 0;
    if (/[a-z]+/.test(this.password)) {
      strength += 1;
    }
    if (/[A-Z]+/.test(this.password)) {
      strength += 1;
    }
    if (/[!@#$%^&*(){}.,_=+\-<>;:]/.test(this.password)) {
      strength += 1;
    }
    if (/[0-9]+/.test(this.password)) {
      strength += 1;
    }
    return strength < 3 && this.password;
  }

  register() {
    this.isActiveNameValidation = true;
    this.isActiveEmailValidation = true;
    this.isActivePasswordValidation = true;
    this.isActivePasswordRepeatValidation = true;
    this.isActiveTermsValidation = true;
    this.emailAddressAlreadyInUse = false;
    this.emailBlacklisted = false;

    if (this.acceptTerms === false) {
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    registrationService
      .createAccount(this.name, this.email, this.password)
      .then(() => {
        this.isLoading = false;
        this.isRegistered = true;
      })
      .catch((data: any) => {
        this.isLoading = false;
        if (data.status === 422) {
          if (data.data && data.data.error && data.data.error.email) {
            if (data.data.error.email[0] && data.data.error.email[0].error === 'blacklisted') {
              this.emailBlacklisted = true;
            } else {
              this.emailAddressAlreadyInUse = true;
            }
          }
        }
      });
  }
  resendActivationEmail() {
    registrationService.resendActivationEmail(this.email).then(data => {
      this.sendMessageInfo = true;
    });
  }
}
